import React from "react";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./redux-saga/store";

function load() {
  const link = document.createElement("link");
  link.href =
    "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700;800&display=swap";
  link.rel = "stylesheet";
  document.head.appendChild(link);
  const script = document.createElement("script");
  script.defer = true;
  script.async = true;
  script.src = process.env?.REACT_APP_GTAG_URL;
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-6X6FRBLJY2");
  };
  document.body.appendChild(script);
}
document.addEventListener("readystatechange", (e) => {
  if (e.target.readyState === "complete") load();
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
